import React from 'react';
import { Heading, SubHeading } from '../../typography';
import { Container } from './MobileAppsHeader.style';

const MobileAppsHeader = () => {
  return (
    <Container>
      <Heading fontSize={32} color="white" style={{ textShadow: '0 0 10px rgba(0, 0, 0, 0.75)' }}>
        Apps us nai.
      </Heading>
      <SubHeading
        fontSize={26}
        fontWeight="400"
        color="white"
        style={{ textShadow: '0 0 10px rgba(0, 0, 0, 0.75)', marginTop: '28px' }}
        maxWidth={835}
      >
        <span>
          The PropertyPal app makes it even easier to find your dream home, search thousands of properties for sale and
          rent across Northern&nbsp;Ireland and Ireland on your mobile or tablet.
        </span>
      </SubHeading>
    </Container>
  );
};

export default MobileAppsHeader;
